<template>
  <div
    id="gamescores"
    class="content"
  >
    <div id="content">
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-gamepad"></i> Mini-Jeu Weezy
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Retrouvez ici le classement du <strong>Mini-jeu Weezy !</strong>
          <br>
          Vous pouvez effectuer une <strong>recherche</strong> par nom ou prénom d'opérateur.
        </b-message>
      </div>
    </div>
    <gameScoresTable
      id="gameScoresTable"
      :scores="scores"
      :users="users"
    />
    <div
      v-if="isAdmin()"
      class="button field is-info is-medium mb2"
      @click="resetAllScores()"
    >
      <span><i class="fa fa-times"></i> Effacer tous les scores</span>
    </div>
  </div>

</template>

<script>
import gameScoresTable from "@/components/gameScoresTable";
import http from "@/modules/request";

export default {
  name: "sales",
  components: {
    gameScoresTable
  },
  data() {
    return {
      scores: [],
      users: []
    };
  },
  mounted() {
    this.getUsers();
    this.getScores();
  },
  methods: {
    isAdmin() {
      return this.$store.state.role == "admin";
    },
    getUsers() {
      http
        .get("/privateusers")
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getScores() {
      http
        .get("/scores")
        .then(response => {
          this.scores = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    resetAllScores() {
      http
        .post("/scores/reset")
        .then(response => {
          this.scores = [];
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    errorToast(message) {
      this.$toast.open({
        duration: 3000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}

.add-sale {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>